import { formatDateHuman, formatCurrency } from "../date-utils";
export const companyInvoicePaymentDtoFields = [{
        name: "urlPdf",
        title: "PDF",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => (record.invoice.urlPdf != null && record.invoice.urlPdf != "" ? `<span class="icon"><i class="material-icons icon-base has-text-success">check</i></span>` : ``)
    }, {
        name: "sendEmail",
        title: "Sollecito inviato",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => {
            if (record.lastPaymentEmail == null)
                return "";
            else {
                if (record.lastPaymentEmail.risultato == "ACCODATO") {
                    return `<span class="icon"><i class="material-icons icon-base has-text-primary">access_time</i></span><span style="display: inline-block;">` + record.lastPaymentEmail.tipoinvio + `<br/>` + formatDateHuman(record.lastPaymentEmail.createdOn) + `</span>`;
                }
                else if (record.lastPaymentEmail.risultato == "OK") {
                    return `<span class="icon"><i class="material-icons icon-base has-text-success">check</i></span><span style="display: inline-block;">` + record.lastPaymentEmail.tipoinvio + `<br/>` + formatDateHuman(record.lastPaymentEmail.createdOn) + `</span>`;
                }
                else
                    return `<span class="icon"><i class="material-icons icon-base has-text-danger">warning</i></span><span style="display: inline-block;">` + record.lastPaymentEmail.tipoinvio + `<br/>` + formatDateHuman(record.lastPaymentEmail.createdOn) + `</span>`;
            }
        }
    }, {
        name: "stato",
        title: "Stato",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => {
            if (record.statosollecitoCode == null)
                return "";
            else {
                if (record.statosollecitoCode == "DASTORNARE") {
                    return `<span class="tag is-info">` + record.statosollecito + `</span>`;
                }
                else if (record.statosollecitoCode == "NOSOLLECIT") {
                    return `<span class="tag is-success">` + record.statosollecito + `</span>`;
                }
                else if (record.statosollecitoCode == "INVALUTAZI") {
                    return `<span class="tag is-warning">` + record.statosollecito + `</span>`;
                }
                else if (record.statosollecitoCode == "INVRECUPCR") {
                    return `<span class="tag is-danger">` + record.statosollecito + `</span>`;
                }
                else //SISOLLECIT
                    return `<span class="tag is-light">` + record.statosollecito + `</span>`;
            }
        }
    }, {
        name: "cliente",
        title: "Cliente",
        render: (record) => record.company.name
    }, {
        name: "numeroFattura",
        title: "N° fattura",
        render: (record) => record.invoice.numeroFattura
    }, {
        name: "ownership",
        title: "Az. proprietaria",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.ownership.name
    }, {
        name: "importo",
        title: "Importo rata",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatCurrency(record.payment.importorata) //new Intl.NumberFormat('it-IT', {style: 'currency',currency: 'EUR',minimumFractionDigits: 2,maximumFractionDigits: 2})
        //.format(record.invoice.importo)
    }, {
        name: "dataEmissione",
        title: "Data Emissione",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.invoice.dataEmissione)
    }, {
        name: "dataScadenza",
        title: "Data Scadenza",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(record.payment.dataScadenza)
    }, {
        name: "referente",
        title: "Referente",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => (record.payment.referente == null ? "" : record.payment.referente)
    }, {
        name: "corso",
        title: "Corso",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => (record.payment.corso == null ? "" : record.payment.corso)
    }, {
        name: "descrizione",
        title: "Descrizione",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => (record.payment.descrizione == null ? "" : record.payment.descrizione)
    }];
